<li nz-menu-item nzMatchRouter *ngIf="menu.ChildMenus.length === 0">
    <a [routerLink]="getMenuUrl(menu)">
        <i nz-icon [nzType]="menu.Icon" nzTheme="outline" *ngIf="menu.Icon !== '' && menu.Icon !== null"></i>
        {{menu.Label | locale}}
    </a>
</li>
<li nz-submenu nzMatchRouter [nzTitle]="menu.Label | locale" *ngIf="menu.ChildMenus.length > 0">
    <ul>
        <li nz-menu-item *ngFor="let subMenu of menu.ChildMenus">
            <a [routerLink]="getMenuUrl(subMenu)" *ngIf="subMenu.Url !== null">
                <i nz-icon [nzType]="subMenu.Icon" nzTheme="outline" *ngIf="subMenu.Icon !== '' && subMenu.Icon !== null"></i> {{subMenu.Label | locale}}
            </a>
            <span *ngIf="subMenu.Url === null">
                {{subMenu.Label | locale}}
            </span>
        </li>
    </ul>
</li>
